import { atom } from "jotai";

export const clientIdAtom = atom<string>(() => {
  const [clientId] = window.location.hostname.split(".");

  if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
    return process.env.REACT_APP_CLIENT_ID || clientId || "tractable";
  }

  return clientId;
});
